'use client';

import React__default from 'react';
import Col from '../../../LayoutSystem/Col.js';
import Row from '../../../LayoutSystem/Row.js';
import { useTranslate } from '../../../Contexts/translator/index.js';
import { useOnBoarding } from '../../context/index.js';
import { ELanguage } from '../../../Utils/constants.js';
import { ImgContainer, Image } from '../../styles.css.js';
import Button from '../../../Button/index.js';
import { Title } from '../Title.js';
import { EStep } from '../../type.js';

var Welcome = function () {
    var t = useTranslate().t;
    var _a = useOnBoarding(), user = _a.user, lang = _a.lang, baseImageUrl = _a.baseImageUrl, setHash = _a.setHash;
    var name = lang === ELanguage.EN ? user === null || user === void 0 ? void 0 : user.lastName : user === null || user === void 0 ? void 0 : user.firstName;
    return (React__default.createElement(Col, null,
        React__default.createElement(Row, { gutter: [40, 0], justify: 'center' },
            React__default.createElement(Col, { xs: 24 },
                React__default.createElement(Row, { gutter: 8 },
                    React__default.createElement(Col, null,
                        React__default.createElement(Title, { title: "".concat(t('Welcome'), ", ").concat(name), subTitle: t("You're all set to embark on a journey with Vietnamworks! Let's begin by getting to know the platform.") })),
                    React__default.createElement(Col, null,
                        React__default.createElement(ImgContainer, { width: '110px', height: '26px' },
                            React__default.createElement(Image, { src: 'https://www.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo.png', alt: 'logo vietnamworks.com', title: 'vietnamworks.com' }))),
                    React__default.createElement(Col, { xs: 24 },
                        React__default.createElement(ImgContainer, { width: '423px', height: '318px' },
                            React__default.createElement(Image, { src: "".concat(baseImageUrl, "/onboarding/welcome.png"), alt: 'logo vietnamworks.com', title: 'vietnamworks.com' }))))),
            React__default.createElement(Col, { xs: 'auto' },
                React__default.createElement(Button, { type: 'primary', size: 'lg', style: { width: 200 }, onClick: function () { return setHash(EStep.PersonalInformatoion); } }, t("Let's go"))))));
};

export { Welcome as default };
//# sourceMappingURL=index.js.map
